/*
 * @Author: Teemo Ding
 * @Date: 2022-02-16 14:23:12
 * @LastEditTime: 2022-06-24 14:49:22
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/Template/index.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { deleteTemplate } from '@/src/request/settings/communication';
import { NEW } from '@/src/tools/constant';
import { CategoryGroupType } from '@/src/types/common/communication';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { getAllLanguage } from 'src/request/common';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import { columns } from '../config';
import css from '../css.module.less';
import { IParams } from '../index';

const Template = ({
  groupedTemplates,
  update,
  disableEdit,
  disableDelete,
  destination,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const { gateway, channelType, communicationUuid } = useParams() as IParams;
  const handleAddTemplate = () => {
    history.push(
      `/settings/communicationDetail/template/${gateway}/${channelType}/${communicationUuid}/${NEW}${
        destination ? '?destination=' + destination : ''
      }`,
    );
  };
  const { data: languages = [] } = useRequest(() => getAllLanguage());
  const { run: _deleteTemplate } = useRequest((uuid) => deleteTemplate(uuid), {
    manual: true,
    onSuccess: () => {
      message.success(getI18n('general.deletedsuccessfully'));
      update();
    },
  });

  const calculateTemplates = (type) => {
    const orderTemplates = (groupedTemplates || []).filter(
      (o) => o.categoryGroup == type,
    );
    const orderTemplatesData = orderTemplates
      .flatMap((item) => item.templates)
      .map((item) => ({
        ...item,
        availableLanguagesNames: item.availableLanguages.map((n) => {
          return ((languages.filter((o) => o.uuid === n) || [])[0] || {})
            .description;
        }),
      }));
    return orderTemplatesData;
  };
  const handleDelete = (uuid) => {
    modal.error({
      title: getI18n('storeCommunicationSetting.detail.deletetemplate'),
      content: getI18n(
        'storeCommunicationSetting.detail.deletetemplatecontent',
      ),
      onOkText: getI18n('general.delete'),
      onOk: () => _deleteTemplate(uuid),
      onCancel: () => {
        return;
      },
    });
  };
  const handleEdit = (uuid) => {
    history.push(
      `/settings/communicationDetail/template/${gateway}/${channelType}/${communicationUuid}/${uuid}${
        destination ? '?destination=' + destination : ''
      }`,
    );
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('storeCommunicationSetting.detail.template')}>
      <h3 className={css.topTitle}>
        {getI18n('storeCommunicationSetting.detail.order')}
      </h3>
      <SizeFittingTable
        id={'Store Setting Available Methods'}
        rowKey={(record) => record?.paymentMethod?.uuid}
        bordered
        rowClassName={css.row}
        className={css.table}
        pagination={false}
        columns={columns(handleDelete, handleEdit, disableEdit, disableDelete, {
          getI18n,
          key: 'Order',
        })}
        dataSource={calculateTemplates(CategoryGroupType.Order)}
      />
      <h3 className={css.title}>
        {getI18n('storeCommunicationSetting.detail.fulfillment')}
      </h3>
      <SizeFittingTable
        id={'Store Setting Available Methods'}
        rowKey={(record) => record?.paymentMethod?.uuid}
        bordered
        rowClassName={css.row}
        className={css.table}
        pagination={false}
        columns={columns(handleDelete, handleEdit, disableEdit, disableDelete, {
          getI18n,
          key: 'Fulfillment',
        })}
        dataSource={calculateTemplates(CategoryGroupType.Fulfillment)}
      />
      <h3 className={css.title}>
        {getI18n('storeCommunicationSetting.detail.customer')}
      </h3>
      <SizeFittingTable
        id={'Store Setting Available Methods'}
        rowKey={(record) => record?.paymentMethod?.uuid}
        bordered
        rowClassName={css.row}
        className={css.table}
        pagination={false}
        columns={columns(handleDelete, handleEdit, disableEdit, disableDelete, {
          getI18n,
          key: 'Customer',
        })}
        dataSource={calculateTemplates(CategoryGroupType.Customer)}
      />
      <h3 className={css.title}>
        {getI18n('storeCommunicationSetting.detail.product')}
      </h3>
      <SizeFittingTable
        id={'Store Setting Available Methods'}
        rowKey={(record) => record?.paymentMethod?.uuid}
        bordered
        rowClassName={css.row}
        className={css.table}
        pagination={false}
        columns={columns(handleDelete, handleEdit, disableEdit, disableDelete, {
          getI18n,
          key: 'Product',
        })}
        dataSource={calculateTemplates(CategoryGroupType.Product)}
      />
      <Button
        type='primary'
        className={css.addTemplate}
        onClick={handleAddTemplate}
        disabled={disableEdit}>
        {getI18n('storeCommunicationSetting.detail.addTemplate')}
      </Button>
    </SectionWrapper>
  );
};

export default Template;
